import { getUserDetails } from "../../../utils/authHelpers";
import { getProfileId } from "../../../utils/validationUtils";
import { getApiInstance } from "../../AppService";
import {
  ACTIVE_BUSINESS_INFO,
  BUSINESS_PRODUCTS_BY_STATUS,
  BUYER_APP_LOOKUP,
  GET_COMMERCE_DASHBOARD_INFO,
  GET_COMMERCE_INFO,
  GET_EMAIL_ACTIVATION,
  MAIN_PRODUCTS,
  MAIN_PRODUCTS_WITH_VARIANTS,
  MY_BUSINESS_DATA,
  ONDC_CATEGORY,
  ONDC_FILTER,
  ONDC_PRODUCT_LIST,
  PRODUCTS_BY_BUSINESS,
  PRODUCT_CATEGORY,
  RESEND_EMAIL_ACTIVATION,
  REVIEW_TABLE_LIST,
  SEARCH_BUSINESS_PRODUCTS,
  VARIANT_COUNT,
  VARIANT_REVIEW_COUNT,
} from "../../constant";

export const getActiveBusinessAPI = async (businessId) => {
  try {
    const instance = getApiInstance();
    const response = await instance.get(ACTIVE_BUSINESS_INFO + businessId);
    console.log("getActiveBusinessAPI", response.data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getProductsByBusinessAPI = async (businessId) => {
  try {
    const instance = getApiInstance();
    const response = await instance.get(PRODUCTS_BY_BUSINESS + businessId, {
      params: {
        business: true,
        percentageOff: false,
        highToLow: false,
        lowToHigh: false,
        pageSize: 500,
        pageNo: 1,
      },
    });
    console.log("getActiveBusinessAPI", response.data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const getActiveProductsByBusinessAPI = async ({
  businessId,
  pageNo,
}) => {
  try {
    const instance = getApiInstance();
    const response = await instance.get(PRODUCTS_BY_BUSINESS + businessId, {
      params: {
        business: true,
        percentageOff: false,
        highToLow: false,
        lowToHigh: false,
        pageSize: 50,
        pageNo: pageNo,
      },
    });
    console.log("getActiveBusinessAPI", response.data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getMainProductsAPI = async (businessId) => {
  try {
    const instance = getApiInstance();
    const response = await instance.get(MAIN_PRODUCTS, {
      params: { pageNo: 1, pageSize: 500 },
      headers: { businessId },
    });
    console.log("getMainProductsAPI", response.data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getMainProductsWithVariantsAPI = async (
  businessId,
  ondcCode = '',
  ondcSubCode = '',
  search = ''
) => {
  try {
    const instance = getApiInstance();
    const response = await instance.get(MAIN_PRODUCTS_WITH_VARIANTS, {
      params: {
        page: 1,
        pageSize: 500,
        ondcCode: ondcCode || "",
        ondcSubCode: ondcSubCode || "",
        search: search || "",
      },
      headers: { businessId },
    });
    console.log("getMainProductsWithVariantsAPI", response.data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

// Get business products by status
export const getBusinessProductsByStatusAPI = async ({
  businessId,
  status,
}) => {
  try {
    const instance = getApiInstance({
      header: {
        businessId,
      },
    });
    const response = await instance.get(BUSINESS_PRODUCTS_BY_STATUS, {
      params: {
        status,
      },
    });
    console.log("getBusinessProductsByStatusAPI", response.data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const searchBusinessProductsAPI = async (data) => {
  try {
    const instance = getApiInstance();
    const response = await instance.get(SEARCH_BUSINESS_PRODUCTS, {
      params: {
        search: data?.query,
        page: 1,
        pageSize: 100,
      },
      headers: { businessId: data?.businessId },
    });
    console.log("getActiveBusinessAPI", response.data);
    if (response?.data?.details?.length > 0) {
      const array = [...response?.data?.details];
      const masterProductVariantIds = array
        ?.filter((item) => item?.variantInfo?.masterProductVariantId) // Filter only those with a master property
        ?.map((item) => item?.variantInfo?.masterProductVariantId); // Map to the master.id property
      const countRes = await getVariantCountAPI(
        data?.businessId,
        masterProductVariantIds
      );

      array.forEach((item) => {
        // Check if the current item has a master property
        if (item.variantInfo?.masterProductVariantId) {
          // Find a matching item in the second array
          const match = countRes?.productVariantCount?.find(
            (e) =>
              e.masterProductVariantId ===
              item.variantInfo?.masterProductVariantId
          );

          // If a match is found, add the count to the first array's object
          if (match) {
            item.count = match.count;
          }
        }
      });

      console.log("getInventoryVariantProductsAPI Hit1", array);

      return { details: array };
    }
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getProductCategoriesAPI = async (businessId) => {
  try {
    const instance = getApiInstance({
      header: {
        businessId,
      },
    });
    const response = await instance.get(PRODUCT_CATEGORY);

    console.log("getProductCategoriesAPI", response.data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getMyBusinessAPI = async (businessId) => {
  try {
    const instance = getApiInstance({
      header: {
        businessId,
      },
    });
    const response = await instance.get(MY_BUSINESS_DATA);

    console.log("getMyBusinessAPI", response.data);
    sessionStorage.setItem("viewBusiness", JSON.stringify(response.data));
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getCommerceInfoAPI = async (businessId) => {
  try {
    const instance = getApiInstance({
      header: {
        businessId,
      },
    });
    const response = await instance.get(GET_COMMERCE_INFO);

    console.log("getCommerceInfoAPI", response.data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const getBuyerAppLookupAPI = async () => {
  try {
    const instance = getApiInstance();
    const response = await instance.get(BUYER_APP_LOOKUP);

    console.log("BUYER_APP_LOOKUP", response.data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

// Commerce info to check business active status: (active, new, submitted)
export const getCommerceDashboardInfoAPI = async (businessId) => {
  try {
    const instance = getApiInstance({
      header: {
        businessId,
      },
    });
    const response = await instance.get(GET_COMMERCE_DASHBOARD_INFO);

    console.log("getCommerceDashboardInfoAPI", response.data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

// Email Verify Data API
export const getEmailActivationAPI = async () => {
  try {
    const instance = getApiInstance();
    const response = await instance.get(GET_EMAIL_ACTIVATION);

    console.log("getEmailActivationAPI", response.data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

// Re-send Verification Email
export const resendEmailActivationAPI = async (newEmail) => {
  const profileid = getProfileId();
  const userDetails = getUserDetails();

  const postData = {
    profileid,
    phone: userDetails?.account?.phonenumber,
    newEmail: newEmail || userDetails?.account?.email,
  };

  console.log("POST_DATA___:", postData);

  try {
    const instance = getApiInstance();
    const response = await instance.post(RESEND_EMAIL_ACTIVATION, postData);

    console.log("resendEmailActivationAPI", response.data);
    return response.data;
  } catch (error) {
    console.log("RESEND_ERROR", error.response?.data?.title);
    if (error.response?.data?.title === "Login already in use")
      return "Login already in use";
  }
};

export const getONDCCategoriesAPI = async (businessId) => {
  try {
    const instance = getApiInstance({
      header: {
        businessId,
      },
    });
    const response = await instance.get(ONDC_CATEGORY);

    console.log("getONDCCategoriesAPI", response.data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const getONDCProductsAPI = async ({ businessId, params }) => {
  try {
    const instance = getApiInstance({
      header: {
        businessId,
      },
    });
    const response = await instance.get(ONDC_FILTER, { params });
    // const response = await instance.get(ONDC_PRODUCT_LIST, { params });

    if (response?.data?.details?.length > 0) {
      const array = [...response?.data?.details];
      const masterProductVariantIds = array
        ?.filter((item) => item?.variantInfo?.masterProductVariantId) // Filter only those with a master property
        ?.map((item) => item?.variantInfo?.masterProductVariantId); // Map to the master.id property
      const countRes = await getVariantCountAPI(
        businessId,
        masterProductVariantIds
      );

      array.forEach((item) => {
        // Check if the current item has a master property
        if (item.variantInfo?.masterProductVariantId) {
          // Find a matching item in the second array
          const match = countRes?.productVariantCount?.find(
            (e) =>
              e.masterProductVariantId ===
              item.variantInfo?.masterProductVariantId
          );

          // If a match is found, add the count to the first array's object
          if (match) {
            item.count = match.count;
          }
        }
      });

      console.log("getInventoryVariantProductsAPI Hit1", array);

      return array;
    }
    return response?.data?.details;
  } catch (error) {
    console.log(error);
  }
};

// Get Review Table products by status
export const getReviewProductsListByStatusAPI = async ({
  businessId,
  status,
}) => {
  try {
    const instance = getApiInstance({
      header: {
        businessId,
      },
    });
    const response = await instance.get(REVIEW_TABLE_LIST, {
      params: {
        status,
        page: 1,
        pageSize: 300,
      },
    });
    console.log("getReviewProductsListByStatusAPI", response.data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getVariantCountAPI = async (
  businessId,
  masterProductVariantIds
) => {
  try {
    const instance = getApiInstance();
    const response = await instance.post(
      VARIANT_COUNT,
      masterProductVariantIds,
      {
        headers: { businessId },
      }
    );
    console.log("getMainProductsAPI", response.data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getReviewVariantCountAPI = async (
  businessId,
  masterProductVariantIds,
  status
) => {
  try {
    const instance = getApiInstance();
    const response = await instance.post(
      VARIANT_REVIEW_COUNT,
      masterProductVariantIds,
      {
        params: {
          status,
        },
        headers: { businessId },
      }
    );
    console.log("getMainProductsAPI", response.data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
